import { useState } from "react";

const RenderDialogContent = ({ selectedMedia }) => {
  const [url, setUrl] = useState("");
  const [format, setFormat] = useState("pptx");
  const [error, setError] = useState("");
  const [downloadLink, setDownloadLink] = useState("");
  if (!selectedMedia) return null;

  const extractPresentationId = (slidesUrl) => {
    try {
      const regex = /\/presentation\/d\/([a-zA-Z0-9_-]+)/;
      const match = slidesUrl.match(regex);

      if (match && match[1]) {
        return match[1];
      }

      throw new Error("Invalid Google Slides URL format");
    } catch (err) {
      setError("Something goes wrong, please try again later.");
      return null;
    }
  };
  // Generate the download link based on the presentation ID and format
  const generateDownloadLink = (presentationId, exportFormat) => {
    // Format mapping
    const formatMap = {
      pdf: "pdf",
      pptx: "pptx",
      txt: "txt",
      jpeg: "jpeg",
      png: "png",
    };

    const formatCode = formatMap[exportFormat] || "pptx";
    return `https://docs.google.com/presentation/d/${presentationId}/export/${formatCode}`;
  };
  const handleSubmit = (url) => {
    if (!url.trim()) {
      setError("Something went wring, please try again later.");
      return;
    }
    setError("");
    const presentationId = extractPresentationId(url);
    if (presentationId) {
      const link = generateDownloadLink(presentationId, format);
      window.open(link, "_blank");
    }
  };
  const handleDownload = (downloadLink) => {
    if (downloadLink) {
      window.open(downloadLink, "_blank");
    }
  };

  return (
    <div className="p-4">
      <iframe
        key={selectedMedia.publishedPpt}
        src={selectedMedia.publishedPpt}
        width="100%"
        height="569"
        mozallowfullscreen="true"
        webkitallowfullscreen="true"
        title={selectedMedia.title}
      ></iframe>

      <h2 className="text-2xl font-bold mb-2">{selectedMedia.title}</h2>
      <div className="flex items-center mb-4">
        <span className="text-gray-600 mr-4">{selectedMedia.date}</span>
        <span className="text-gray-600 mr-4">{selectedMedia.presenter}</span>
      </div>

      {/* Download Button (stays in its own row) */}
      <div className="mb-4">
        <button
          className="border border-blue-500 text-blue-500 hover:bg-blue-50 px-4 py-2 rounded flex items-center gap-2"
          onClick={() => handleDownload(selectedMedia.pptUrl)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
            <path
              fillRule="evenodd"
              d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
              clipRule="evenodd"
            />
          </svg>
          View Presentation
        </button>
      </div>

      {/* Export Format & Generate Link (stacked vertically) */}
      <div className="space-y-4">
        <div>
          <label
            htmlFor="format"
            className="block text-lg font-bold font-medium text-gray-700 mb-1"
          >
            Export Format
          </label>
          <select
            id="format"
            value={format}
            onChange={(e) => setFormat(e.target.value)}
            className="border border-blue-500 text-blue-500 hover:bg-blue-50 px-4 py-2 rounded flex items-center gap-2"
          >
            <option value="pptx">PowerPoint (.pptx)</option>
            <option value="pdf">PDF (.pdf)</option>
            <option value="txt">Plain Text (.txt)</option>
            <option value="jpeg">JPEG Images (.jpeg)</option>
            <option value="png">PNG Images (.png)</option>
          </select>
        </div>

        <button
          onClick={() => handleSubmit(selectedMedia.pptUrl)}
          className="border border-blue-500 text-blue-500 hover:bg-blue-50 px-4 py-2 rounded flex items-center gap-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
          Download
        </button>
      </div>

      {error && (
        <div className="mt-4 p-2 bg-red-100 border border-red-400 text-red-700 rounded">
          {error}
        </div>
      )}
    </div>
  );
};

export default RenderDialogContent;
